/* ============================================================================
 * Project        : Deloitte Digital Compliance
 * File           : roletypeActions.js
 * Version        : 1.0.0
 * Author         : Team Neubinary
 * Created On     : 2026-06-24
 *
 * Description    : Digital Compliance for Automation and Governance
 *
 * Change History :
 * ----------------------------------------------------------------------------
 * Date         | Version | Author           | Description
 * ----------------------------------------------------------------------------
 * 2026-06-24   | 1.0.0   | Team Neubinary   | Initial creation
 * <YYYY-MM-DD> | x.x.x   | <Name/Team>      | <Change description>
 * ============================================================================
 *
 * Copyright (c) 2026 AU79 Consulting Services Pvt. Ltd.
 * All Rights Reserved.
 *
 * This source code and its contents are confidential and proprietary to
 * AU79 Consulting Services Pvt. Ltd. Unauthorized copying, reproduction,
 * modification, distribution, or disclosure of this material, in whole or
 * in part, is strictly prohibited without prior written permission from
 * AU79 Consulting Services Pvt. Ltd.
 * ============================================================================
 */
import actionType from "../actionTypes";

const roletypeActions = {
  add_roletype: {
    api_name: "/UCM/role-types/",
    action_type: actionType.ADD_ROLETYPE,
    https_method: "POST",
    description: "",
  },
  get_all_roletype: {
    api_name: "/UCM/role-types/",
    action_type: actionType.GETALL_ROLETYPE,
    https_method: "GET",
    description: "",
  },
  get_roletype_by_id: {
    api_name: "/UCM/role-types/{id}",
    action_type: actionType.GET_ROLETYPE,
    https_method: "GET",
    description: "",
  },
  update_roletype_meta: {
    api_name: "/UCM/role-types/{id}",
    action_type: actionType.UPDATE_ROLETYPE,
    https_method: "PUT",
    description: "",
  },
  deactivate_roletype: {
    api_name: "/UCM/role-types/{id}",
    action_type: actionType.DEACTIVATE_ROLETYPE,
    https_method: "DELETE",
    description: "",
  },
  attach_policy_roletype: {
    api_name: "/UCM/role-types/{id}/policies",
    action_type: actionType.ATTACH_ROLETYPE,
    https_method: "POST",
    description: "",
  },
  detach_policy_roletype: {
    api_name: "/UCM/role-types/{id}/policies",
    action_type: actionType.DETACH_ROLETYPE,
    https_method: "DELETE",
    description: "",
  },
};

export default roletypeActions;
